module.exports = __webpack_public_path__ + "img/maja-ser-det-fede-2.5ae461b1.png";